import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import theme from "./src/theme/lightTheme";
import Layout from "./src/Layouts/Layout";
import createEmotionCache from "./src/createEmotionCache";

const cache = createEmotionCache();

export const shouldUpdateScroll = ({ routerProps: { location } }: any) => {
  // Check if the new URL has a hash (e.g., /page#section)
  if (location.hash) {
    // If it has a hash, return true or null to let the browser handle the anchor scrolling
    return true;
  }

  window.scrollTo(0, 0);
  return false; // Tells Gatsby's default behavior to not run
};

export const wrapRootElement = ({ element }: any) => (
  <CacheProvider value={cache}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout>{element}</Layout>
    </ThemeProvider>
  </CacheProvider>
);
